import React from 'react'

const About = () => {
    return (
        <div>
            {/* start header section */}
            <section className="call-to-action ptb-100 background-img"
             style={{background: "url('img/img2.png')", backgroundRepeat:"no-repeat", backgroundPosition: "center", backgroundSize: "center / cover", backgroundAttachment: "fixed"}}>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-11">
                            <div className="call-to-action-content text-center text-white">
                                <h2 className="text-white">Discover NCC Media. It’s easier than you think</h2>
                                <p>Progressively deliver market-driven quality results to engage the most valuable customers with your business ideas.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* end header section */}
        </div>
    )
}


export default About;